import { render, staticRenderFns } from "./KoioteTablaProperties.vue?vue&type=template&id=0ede28d0&scoped=true"
import script from "./KoioteTablaProperties.vue?vue&type=script&lang=js"
export * from "./KoioteTablaProperties.vue?vue&type=script&lang=js"
import style0 from "./KoioteTablaProperties.vue?vue&type=style&index=0&id=0ede28d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ede28d0",
  null
  
)

export default component.exports